export const validateCEP = (value: string) => new RegExp(/^\d{5}-\d{3}$/g).test(value)
